import { useMemo } from "react";
import { Organization } from "../../../services/organization/organizationModel";
import { useTranslation } from "react-i18next";
import { prettifySepa } from "../../../react-helpers/stripe";

const ProPaymentMethodForm = ({
  organization,
}: {
  organization: Organization;
}) => {
  const { t } = useTranslation(["organization"]);

  const card = useMemo(() => organization.stripeCustomer?.card, [organization]);
  const isOrganizationCardExpired = useMemo(() => {
    if (!organization?.stripeCustomer?.card) return true;

    const card = organization.stripeCustomer.card;
    const today = new Date();
    if (card.exp_year < today.getFullYear()) return true;
    if (
      card.exp_month < today.getMonth() + 1 &&
      card.exp_year == today.getFullYear()
    )
      return true;

    return false;
  }, [organization]);
  const sepa = useMemo(() => organization.stripeCustomer?.sepa, [organization]);

  return (
    <div className="admin-pay">
      {!card && !sepa && (
        <div className="ui-banner --err">
          <div>
            {t("organization:subscription.payment-method.YOU_NEED_TO")}{" "}
            <button
              type="button"
              className="link --underlined"
              onClick={() =>
                window.open(
                  `/organization/pro/subscription/payment-method`,
                  "_blank",
                )
              }
            >
              {t(
                "organization:subscription.payment-method.RECORD_A_PAYMENT_METHOD",
              )}
            </button>
          </div>
        </div>
      )}

      {card && (
        <div className="admin-pay_method">
          <span className="admin-pay_brand">
            {card.display_brand.toLocaleUpperCase()}
          </span>
          <div>
            <b className="ui-num">•••• {card.last4}</b>
            <p className="ui-muted ui-small">
              {t("organization:subscription.payment-method.EXPIRE", {
                replace: {
                  date: `${card.exp_month}/${card.exp_year}`,
                },
              })}{" "}
              {isOrganizationCardExpired && (
                <span className="ui-chip --err">
                  {t("organization:subscription.payment-method.EXPIRED")}
                </span>
              )}
            </p>
          </div>
        </div>
      )}

      {sepa && (
        <div className="admin-pay_method">
          <span className="admin-pay_brand">SEPA</span>
          <b>{prettifySepa(sepa)}</b>
        </div>
      )}

      {(!!card || !!sepa) && (
        <button
          className="btn--soft --btn--s"
          type="button"
          onClick={() =>
            window.open(
              `/organization/pro/subscription/payment-method`,
              "_blank",
            )
          }
        >
          {t("organization:subscription.payment-method.UPDATE_PAYMENT_METHOD")}
        </button>
      )}
    </div>
  );
};

export default ProPaymentMethodForm;
